<template>
  <div>
    <div v-if="loading" class="loading-box">
      <BaseLoading/>
    </div>
    <slot v-else/>
  </div>
</template>

<script>
import BaseLoading from "@/components/BaseLoading";
import {refreshToken} from "@/httpservices/User";
import moment from "jalali-moment";

export default {
  components: {BaseLoading},
  data() {
    return {
      loading: false,
    }
  },
  mounted() {
    this.fetchRefreshToken();
  },
  methods: {
    async fetchRefreshToken() {
      this.loading = true;
      try {
        const expireTime = localStorage.getItem('tokenExpire') * 1000;
        const isUpdatingRefreshToken = localStorage.getItem('updatingRefreshToken');
        const now = new Date().getTime();
        const diff = moment(new Date(expireTime)).diff(new Date(now), 'hours')
        // if (diff < 2) {
        localStorage.setItem('updatingRefreshToken', "on")
        const {data} = await refreshToken();
        console.log({data})
        localStorage.setItem('token', data.accessToken)
        localStorage.setItem('tokenExpire', data.expires)
        localStorage.setItem('updatingRefreshToken', 'off');
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.loading-box {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
</style>
